(() => {
  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const reveal = (section) => section.classList.add('section-anim-in');
  function initialize() {
    observer?.disconnect();
    root.classList.remove('theme-animations-ready');
    const sections = document.querySelectorAll('.shopify-section');
    if (reducedMotion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }
    try {
      observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          target.classList.toggle('section-in-view', isIntersecting);
          if (isIntersecting) {
            reveal(target);
            target.dispatchEvent(new CustomEvent('section:in-viewport'));
          }
        });
      }, { threshold: 0 });
      sections.forEach((section) => {
        const bounds = section.getBoundingClientRect();
        if (bounds.top < window.innerHeight && bounds.bottom > 0) reveal(section);
        observer.observe(section);
      });
      root.classList.add('theme-animations-ready');
    } catch (error) {
      observer?.disconnect();
      sections.forEach(reveal);
    }
  }
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', (event) => observer?.unobserve(event.target));
  reducedMotion.addEventListener('change', initialize);
  initialize();
})();
